import { postApi } from "./api_instance";

export const withdrawAmount = async (amount, bank_account, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: `/payments/api/wallet/withdraw-request`,
      dispatch,
      sendToken: true,
      data: {
        amount,
        bank_account,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
